/* eslint-disable @typescript-eslint/member-ordering */
import { Component, input, InputSignal, output } from '@angular/core';
import { IconComponent } from '../../../../icons';
import { DrawerResult, DrawerState } from '../../drawer.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'da-drawer-header',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './drawer-header.component.html',
})
export class DrawerHeaderComponent {
  public drawer: InputSignal<DrawerState> = input.required();
  public close = output<DrawerResult>();

  public i18n: Record<string, string> = this.translateService.instant([
    'Core_Close',
  ]);

  public drawerClose() {
    this.close.emit({ result: 'close' });
  }

  constructor(private translateService: TranslateService) {}
}
